//import Button from 'olive-react-myoneui/lib/Button';
//import SampleImage2 from '../../../assets/images/sample2.jpg';
import IconDesc from '../my-course/IconDesc';
import { documents } from '../../../constants/icons';
import { useSelector } from 'react-redux';

function CourseBlock({ className, courseDetails, onClick, keyId }) {
  const paths = useSelector((state) => state.user.paths);
  let defaultImage = paths.default_course;
  let imagePath = paths.course_path + courseDetails.cb_image;
  //console.log(courseDetails, 'courseDetailssdsdsd');
  return (
    <div className={`${className || ''} course-block carousel-block p-0 me-1`}>
      <div className="img-carousel" onClick={onClick}>
        <img
          src={imagePath}
          className="img-fluid"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = defaultImage;
          }}
        />
      </div>
      <div className="desc-carousel" onClick={onClick}>
        <h1>{courseDetails.cb_title}</h1>
        <p
          dangerouslySetInnerHTML={{
            __html: courseDetails.cb_short_description,
          }}
        />
        <IconDesc
          icon={documents}
          paraDesc={`${courseDetails.lecture_count} ${courseDetails.lecture_count > 1 ? "Lectures" : "Lecture"} `}
        />
      </div>
    </div>
  );
}

export default CourseBlock;
